import * as React from 'react';
import { Container, Dropdown, Tab, Tabs } from "react-bootstrap";
import { RoomRevenue } from "./RoomRevenue";
import { Departments } from "./Departments";
import { Summary } from "./Summary";
export class OperationalBudgetsDetails extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedYear: this.props.selectedYear,
            hidValue: this.props.hidValue
        };
    }

    render() {
        return (
            <div className='full-screen-modal modal'>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header d-flex align-items-center">
                            <div className="modal-title page-title mr-auto">
                                <div>DTMT 2025 Budget</div>
                                <div className="sub-txt">Total Rooms: <span>130</span></div>
                            </div>
                            <div className="action">
                                <div className='closeMdl' onClick={() => this.props.handleOperationalBudgetsDetailsModal(false)}>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.725 4.28254C13.4325 3.99004 12.96 3.99004 12.6675 4.28254L9.00004 7.94254L5.33254 4.27504C5.04004 3.98254 4.56754 3.98254 4.27504 4.27504C3.98254 4.56754 3.98254 5.04004 4.27504 5.33254L7.94254 9.00004L4.27504 12.6675C3.98254 12.96 3.98254 13.4325 4.27504 13.725C4.56754 14.0175 5.04004 14.0175 5.33254 13.725L9.00004 10.0575L12.6675 13.725C12.96 14.0175 13.4325 14.0175 13.725 13.725C14.0175 13.4325 14.0175 12.96 13.725 12.6675L10.0575 9.00004L13.725 5.33254C14.01 5.04754 14.01 4.56754 13.725 4.28254Z" fill="white" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body">
                            <Tabs defaultActiveKey="roomRevenue" id="operationalBudget-tab">
                                <Tab eventKey="roomRevenue" title="Room Revenue">
                                    <RoomRevenue
                                        selectedYear={this.state.selectedYear}
                                        hidValue={this.state.hidValue}
                                    />
                                </Tab>
                                <Tab eventKey="departments" title="Departments">
                                    <Departments
                                        selectedYear={this.state.selectedYear}
                                        hidValue={this.state.hidValue}
                                    />
                                </Tab>
                                <Tab eventKey="summary" title="Summary">
                                    <Summary />
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}